import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  get,
} from 'lodash';
import {
  API,
  SidePanelContainer,
  SidePanelContent,
  SidePanelFooter,
  SidePanelSection,
  VibeCheckbox,
  VibeSplash,
  VibeButton,
  Field2 as Field,
  color,
} from 'vibeguide';
import AlertEmailSettings from './AlertEmailSettings';

class AlertMemoryConfig extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      configFetched: false,
      enableMemoryAvailable: false,
      memoryAvailable: 20,
      emailFlaggedLocations: false,
      recipients: [],
      suppressNotificationMinutes: 0,
    };
  }

  componentDidMount() {
    this.getConfig();
  }

  /**
   * When the email settings are changed
   */
  onUpdateEmailSettings = (data) => {
    this.setState(data);
  };

  onChangeSelect = ({
    name,
    checked,
  }) => {
    this.setState({
      [name]: checked,
    });
  };

  onChangePercentage = (e) => {
    const {
      target: {
        name,
        value,
      },
    } = e;

    this.setState({
      [name]: parseInt(value, 10),
    });
  };

  getConfig = async () => {
    const config = await API.Location.Alerts.Memory.get();

    this.setState({
      configFetched: true,
      enableMemoryAvailable: get(config, 'low_memory.active', false),
      memoryAvailable: get(config, 'low_memory.threshold', '?'),
      emailFlaggedLocations: get(config, 'emailNotification.emailFlaggedLocations', false),
      recipients: get(config, 'emailNotification.recipients', []),
      suppressNotificationMinutes: get(config, 'suppressNotificationMinutes', 0),
    });
  };

  save = async () => {
    const {
      onToast,
    } = this.props;

    const {
      enableMemoryAvailable,
      memoryAvailable,
      emailFlaggedLocations,
      recipients,
      suppressNotificationMinutes,
    } = this.state;

    const data = {
      low_memory: {
        active: enableMemoryAvailable,
        threshold: memoryAvailable,
      },
      emailNotification: {
        emailFlaggedLocations,
        recipients,
      },
      suppressNotificationMinutes,
    };

    onToast({
      type: 'info',
      title: 'Saving...',
      allowClose: true,
    });

    const saveResponse = await API.Location.Alerts.Memory.update(data);

    if (get(saveResponse, '[0].type') !== 'SYSTEMSETTING.UPDATED') {
      onToast({
        type: 'error',
        title: 'Error updating setting',
        timeout: 10,
        allowClose: true,
      });

      return;
    }

    onToast({
      type: 'success',
      title: 'Saved!',
      allowClose: true,
      delay: 500,
    });
  };

  render() {
    const {
      className,
    } = this.props;

    const {
      configFetched,
      enableMemoryAvailable,
      memoryAvailable,
      emailFlaggedLocations,
      recipients,
      suppressNotificationMinutes,
    } = this.state;

    if (!configFetched) {
      return (
        <VibeSplash
          type="loading"
          size={64}
          style={{
            color: color.primary,
          }}
        />
      );
    }

    return (
      <SidePanelContainer className={classNames('AlertSidebarConfig', 'AlertMemoryConfig', className)}>
        <SidePanelContent>
          <SidePanelSection className="section" title="Send alert when:">
            <div className="section-content">
              <div className="setting">
                <VibeCheckbox
                  rootStyle={{
                    flexGrow: 1,
                  }}
                  name="enableMemoryAvailable"
                  label="Available memory is below:"
                  size={16}
                  color={color.success}
                  checked={enableMemoryAvailable}
                  onChange={this.onChangeSelect}
                />

                <Field
                  className="setting-input"
                  type="number"
                  name="memoryAvailable"
                  value={memoryAvailable}
                  numberProps={{
                    min: 0,
                    max: 100,
                  }}
                  onChange={this.onChangePercentage}
                  disabled={!memoryAvailable}
                />
              </div>
            </div>
          </SidePanelSection>

          <AlertEmailSettings
            emailFlaggedLocations={emailFlaggedLocations}
            recipients={recipients}
            suppressNotificationMinutes={suppressNotificationMinutes}
            onUpdate={this.onUpdateEmailSettings}
          />
        </SidePanelContent>

        <SidePanelFooter>
          <VibeButton
            text="Save Changes"
            color="secondary"
            onClick={this.save}
          />
        </SidePanelFooter>
      </SidePanelContainer>
    );
  }
}

AlertMemoryConfig.propTypes = {
  className: PropTypes.string,
  onToast: PropTypes.func,
};

AlertMemoryConfig.defaultProps = {
  className: '',
  onToast: () => {},
};

export default AlertMemoryConfig;
